<script setup>
import { getI18n } from '@/plugins/i18n'

import { DxDataGrid } from 'devextreme-vue/data-grid'

import * as dataGrid from '@/composables/data-grid'
import { useRegistryStore } from '@/stores/registry.store'

const props = defineProps({
  supplierBrandId: {
    type: Number,
    required: true
  }
})

const gridId = 'transmission-grid'

const i18n = getI18n()
const registryStore = useRegistryStore()

const { gridRef } = dataGrid.useGridRef()

const gridDataSource = dataGrid.useODataSource(registryStore.api.getAbsoluteUrl() + registryStore.api.supplierBrandTransmissionsUrl,
  { filter: ['portal_supplier_brand', '=', props.supplierBrandId] }
)

const columns = [
  {
    dataField: 'branch',
    caption: i18n.t('common.branch'),
    lookup: dataGrid.useLookup({
      dataSource: registryStore.getLocalizedBranches(),
    }),
    validationRules: [{ type: 'required' }]
  },
  { dataField: 'transmission_code', caption: i18n.t('common.transmissionCode'), validationRules: [{ type: 'required' }] },
  { dataField: 'transmission_internal_code', caption: i18n.t('common.transmissionInternalCode') },
  { dataField: 'transmission_company_code', caption: i18n.t('common.transmissionCompanyCode') },
  { dataField: 'transmission_link_code', caption: i18n.t('common.transmissionLinkCode') },
  {
    dataField: 'settle_remaining',
    caption: i18n.t('common.settleRemaining'),
    dataType: 'boolean',
    alignment: 'center',
  },
]

const gridOptions = dataGrid.useDefaultGridOptions({
  id: gridId,
  dataSource: gridDataSource,
  columns: columns,
  columnChooser: {
    enabled: false,
  },
  height: '100%',
})

</script>
<template>
  <div>
    <dx-data-grid
      ref="gridRef"
      v-bind="gridOptions"
      class="q-mb-lg"
    />
  </div>
</template>
<style>
</style>
